import type { NamePath } from 'antd/lib/form/interface';
import { type ReactElement, useEffect } from 'react';
import { Item } from '../item';

export type EmptyInputContentProperties<T> = {
  name: NamePath;
  onChange?: (value: T) => void;
  onSetOnChange?: (value: (value: T) => void) => void;
};

type ContentProperties<T> = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  onChange?: (value: any) => void;
  onSetOnChange?: (value: (value: T) => void) => void;
  onUpdate?: (value: T) => void;
  value?: T;
};

const EmptyInputContent = <T,>({ onChange, onSetOnChange, onUpdate, value }: ContentProperties<T>): ReactElement => {
  useEffect(() => {
    if (onUpdate && value) {
      onUpdate(value);
    }

    if (onSetOnChange && onChange) {
      onSetOnChange(onChange);
    }
  }, [value, onUpdate, onChange, onSetOnChange]);

  // eslint-disable-next-line react/jsx-no-useless-fragment -- Fix this
  return <></>;
};

const EmptyInput = <T,>({ name, onChange, onSetOnChange }: EmptyInputContentProperties<T>): ReactElement => (
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  <Item name={name} noStyle>
    <EmptyInputContent onSetOnChange={onSetOnChange} onUpdate={onChange} />
  </Item>
);

export default EmptyInput;
